import React, { useState, useEffect, useRef } from 'react'; // Adiciona useRef
import { Container, Row, Col, Tabs, Tab, Form, Button, ListGroup, Badge, Card, Modal, Alert, Table, Spinner, InputGroup, Image } from 'react-bootstrap'; // Adicionado InputGroup e Image
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../index.css'; // Import a CSS file for styling (create one if you don't have it)
import { useEntidadeContext } from '../EntidadeContext';
import { useUserContext } from '../UserContext'; // Importar o contexto do usuário
import logoImage from '../img/logo.png'; // Importa a imagem da logo

import ColaboradoresTab from '../components/pessoal/ColaboradoresTab'; // Importar o novo componente
import FolhaPagamentoTab from '../components/pessoal/FolhaPagamentoTab';

const formatCurrency = (value) => {
  // Ensure value is a number before formatting
  const numericValue = parseFloat(value);
  if (isNaN(numericValue)) return 'R$ 0,00';
  return numericValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};



const PessoalPage = () => {

  const navigate = useNavigate();
  const { currentUserRole, getPermittedInternalTabs, isLoadingAccessConfig, dynamicAccessConfig } = useUserContext(); // Obter estados do contexto
  const { currentEntidade, isLoadingEntidade } = useEntidadeContext(); // Adiciona isLoadingEntidade

  const [setores, setSetores] = useState([]);
  const [allFuncionarios, setAllFuncionarios] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [perfis, setPerfis] = useState([]); // Novo estado para perfis

  // Modal states
  const [showFuncionarioModal, setShowFuncionarioModal] = useState(false);
  const [isEditingFuncionario, setIsEditingFuncionario] = useState(false);
  const [funcionarioToEdit, setFuncionarioToEdit] = useState(null);
  const [creatingSetor, setCreatingSetor] = useState(false);
  const [creatingCargo, setCreatingCargo] = useState(false);
  const [creatingFuncionario, setCreatingFuncionario] = useState(false);

  // States for backend messages
  const [setorMessage, setSetorMessage] = useState(null);
  const [cargoMessage, setCargoMessage] = useState(null);
  const [funcionarioMessage, setFuncionarioMessage] = useState(null);

  // Modal form states
  const [selectedSetorModal, setSelectedSetorModal] = useState('');
  const [cargosDoSetorModal, setCargosDoSetorModal] = useState([]);
  const [isLoadingCargosModal, setIsLoadingCargosModal] = useState(false);

  // Loading states for each delete action
  const [deletingSetor, setDeletingSetor] = useState(false);
  const [deletingCargo, setDeletingCargo] = useState(false);
  const [deletingFuncionario, setDeletingFuncionario] = useState(false);
  const [isLoadingFuncionarios, setIsLoadingFuncionarios] = useState(false);

  // Flag para controlar a busca inicial de dados
  const fetchDataAttemptedInThisMount = useRef(false);

  // Estados para Lançamentos Variáveis da Folha
  const [selectedFuncionarioLancamento, setSelectedFuncionarioLancamento] = useState(''); // ID do funcionário selecionado
  const [mesLancamento, setMesLancamento] = useState(new Date().getMonth() + 1); // Mês atual
  const [anoLancamento, setAnoLancamento] = useState(new Date().getFullYear()); // Ano atual
  const [lancamentosVariaveis, setLancamentosVariaveis] = useState([]);
  const [isLoadingLancamentos, setIsLoadingLancamentos] = useState(false);
  const [lancamentoMessage, setLancamentoMessage] = useState(null);
  
  // Estados para o NOVO Modal de Lançamentos Variáveis
  const [showLancamentoVariavelModal, setShowLancamentoVariavelModal] = useState(false);
  const [currentLancamentoVariavel, setCurrentLancamentoVariavel] = useState(null); // Para edição
  const [newLancamentoVariavelData, setNewLancamentoVariavelData] = useState({
    descricao: '',
    tipo: 'provento',
    valor: '',
    referencia: '',
  });
  // Estados para a Folha de Pagamento
  const [mesFolha, setMesFolha] = useState(new Date().getMonth() + 1); // Mês atual
  const [anoFolha, setAnoFolha] = useState(new Date().getFullYear()); // Ano atual
  const [dadosFolhaPagamento, setDadosFolhaPagamento] = useState([]);
  const [isLoadingFolha, setIsLoadingFolha] = useState(false);
  const [resumoFolha, setResumoFolha] = useState({ totalBruto: 0, totalDescontos: 0, totalLiquido: 0 });
  const [isProcessingFolhaFinal, setIsProcessingFolhaFinal] = useState(false);

  const [showDetalhesHoleriteModal, setShowDetalhesHoleriteModal] = useState(false);
  const [holeriteSelecionadoDetalhes, setHoleriteSelecionadoDetalhes] = useState(null);
  const [isLoadingDetalhesHolerite, setIsLoadingDetalhesHolerite] = useState(false);

  // Obter abas permitidas para Pessoal
  const permittedTabs = React.useMemo(() => {
    return getPermittedInternalTabs('pessoal', currentUserRole);
    },
    [getPermittedInternalTabs, currentUserRole, isLoadingAccessConfig, dynamicAccessConfig]
  );
  // Define a aba ativa inicial para a primeira permitida, ou 'colaboradores' como fallback
  const [activePessoalTab, setActivePessoalTab] = useState(permittedTabs[0]?.key || 'colaboradores');

  // Ajusta a aba ativa se a atual não for permitida para a role (useEffect)
  useEffect(() => {
    if (permittedTabs.length > 0 && !isLoadingAccessConfig && !permittedTabs.some(tab => tab.key === activePessoalTab)) { // Garante que o loading terminou
        setActivePessoalTab(permittedTabs[0].key);
    } }, [activePessoalTab, permittedTabs, isLoadingAccessConfig]); // Ajustadas dependências

  const [newFuncionarioData, setNewFuncionarioData] = useState({
    nome: '',
    cpf: '',
    email: '',
    dddcelular: '',
    celular: '',
    dddtelefone: '',
    telefone: '',
    data_nascimento: '',
    sexo: 'N', // Valor padrão
    estado_civil: 'Nao informado', // Valor padrão
    cor: 'Nao Informado', // Valor padrão
    mae: '',
    pai: '',
    cep: '',
    tipoendereco: 'Residencial', // Valor padrão
    estado: '',
    cidade: '',
    bairro: '',
    endereco: '',
    numero: '',
    complemento: '',
    obs: '',
    cargo_id: '', 
    salario_base: '', // Adicionado salario_base
    especialidade_id: null,
    tipo_contrato: 'CLT', // <<--- CORREÇÃO: Adicionado valor padrão
    comissionavel: false, // Novo campo para comissão
    comissionavel_origem: false, // NOVO CAMPO: Para comissão originária
    entidade_id: currentEntidade ? currentEntidade.id : null,
  });

  useEffect(() => {
    // Se esta é a segunda execução do useEffect pelo StrictMode NESTA montagem,
    // e a busca já foi tentada, OU se a entidade não carregou, não faz nada.
    if (fetchDataAttemptedInThisMount.current || !currentEntidade || isLoadingEntidade) {
      return;
    }

    setNewFuncionarioData(prev => ({ ...prev, entidade_id: currentEntidade.id }));

      const fetchInitialData = async () => {
        try {
          setIsLoadingFuncionarios(true);
          const [setoresRes, funcionariosRes, especialidadesRes, perfisRes] = await Promise.all([
            axios.get(`/api/setores?entidade_id=${currentEntidade.id}`),
            axios.get(`/api/funcionarios?entidade_id=${currentEntidade.id}`),
            axios.get('/api/especialidades'), // Geralmente especialidades são globais ou filtradas por entidade no backend
            axios.get(`/api/perfis?entidade_id=${currentEntidade.id}`) // Busca perfis
          ]);
          setSetores(setoresRes.data.setores || []);
          setAllFuncionarios(funcionariosRes.data.funcionarios || []);
          setEspecialidades(especialidadesRes.data.especialidades || []);
          setPerfis(perfisRes.data.perfis || []); // Armazena os perfis
        } catch (error) {
          console.error('Error fetching initial data:', error);
          setFuncionarioMessage({ type: 'danger', text: 'Erro ao carregar dados iniciais.' });
        } finally {
          setIsLoadingFuncionarios(false);
        }
      };

    // Marca que a tentativa de busca de dados para esta montagem está ocorrendo.
    fetchDataAttemptedInThisMount.current = true;

    if (currentEntidade && !isLoadingEntidade) { // Garante que a entidade esteja carregada
      fetchInitialData();
    }
  }, [currentEntidade, isLoadingEntidade]); // Adiciona isLoadingEntidade às dependências

  useEffect(() => {
    const fetchCargosBySetorModal = async () => {
      if (selectedSetorModal && currentEntidade) {
        setIsLoadingCargosModal(true);
        try {
          const response = await axios.get(`/api/setores/${selectedSetorModal}/cargos?entidade_id=${currentEntidade.id}`);
          setCargosDoSetorModal(response.data.cargos || []);
        } catch (error) {
          console.error('Error fetching cargos for modal:', error);
          setCargosDoSetorModal([]);
        } finally {
          setIsLoadingCargosModal(false);
        }
      } else {
        setCargosDoSetorModal([]);
      }
    };
    fetchCargosBySetorModal();
  }, [selectedSetorModal, currentEntidade]);


  const handleOpenFuncionarioModal = (funcionario = null) => {
    if (funcionario) {
      setIsEditingFuncionario(true);
      setFuncionarioToEdit(funcionario);
      setSelectedSetorModal(funcionario.cargo?.setor_id || ''); // Assumindo que a API retorna cargo.setor_id
      setNewFuncionarioData({
        ...funcionario,
        data_nascimento: funcionario.data_nascimento ? funcionario.data_nascimento.split('T')[0] : '',
        cargo_id: funcionario.cargo_id || '',
        salario_base: funcionario.salario_base || '', // Adicionado salario_base
        especialidade_id: funcionario.especialidade_id || null,
        comissionavel: funcionario.comissionavel || false, // Adicionado comissionavel
        comissionavel_origem: funcionario.comissionavel_origem || false, // NOVO CAMPO
        entidade_id: currentEntidade.id
      });
    } else {
      setIsEditingFuncionario(false);
      setFuncionarioToEdit(null);
      setSelectedSetorModal('');
      setCargosDoSetorModal([]);
      setNewFuncionarioData({
        nome: '', cpf: '', email: '', dddcelular: '', celular: '', dddtelefone: '', telefone: '',
        data_nascimento: '', sexo: 'N', estado_civil: 'Nao informado', cor: 'Nao Informado',
        mae: '', pai: '', cep: '', tipoendereco: 'Residencial', estado: '', cidade: '', tipo_contrato: 'CLT', // <<--- CORREÇÃO: Adicionado valor padrão
        bairro: '', endereco: '', numero: '', complemento: '', obs: '', salario_base: '', comissionavel: false, comissionavel_origem: false, // NOVO CAMPO
        cargo_id: '', especialidade_id: null, entidade_id: currentEntidade.id,
      });
    }
    setShowFuncionarioModal(true);
  };

  const handleCloseFuncionarioModal = () => {
    setShowFuncionarioModal(false);
    setIsEditingFuncionario(false);
    setFuncionarioToEdit(null);
    setFuncionarioMessage(null);
  };

  const handleFuncionarioInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewFuncionarioData({
      ...newFuncionarioData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSaveFuncionario = async () => {
    if (!newFuncionarioData.cargo_id) {
      setFuncionarioMessage({ type: 'danger', text: 'Por favor, selecione um setor e um cargo.' });
      return;
    }
    if (!currentEntidade) {
        setFuncionarioMessage({ type: 'danger', text: 'Entidade não identificada.' });
        return;
    }

    const dataPayload = {
        ...newFuncionarioData,
        entidade_id: currentEntidade.id,
        data_nascimento: newFuncionarioData.data_nascimento || null, // Enviar null se vazio
    };

    try {
      setCreatingFuncionario(true);
      setFuncionarioMessage(null);
      let response;
      if (isEditingFuncionario && funcionarioToEdit) {
        response = await axios.put(`/api/funcionarios/${funcionarioToEdit.id}`, dataPayload);
        setAllFuncionarios(allFuncionarios.map(f => f.id === funcionarioToEdit.id ? response.data.funcionario : f));
        setFuncionarioMessage({ type: 'success', text: response.data.message || 'Funcionário atualizado com sucesso!' });
      } else {
        response = await axios.post('/api/funcionarios', dataPayload);
        setAllFuncionarios([...allFuncionarios, response.data.funcionario]);
        setFuncionarioMessage({ type: 'success', text: response.data.message || 'Funcionário criado com sucesso!' });
      }
      handleCloseFuncionarioModal();
      // Refetch all funcionarios to ensure list is up-to-date with potential backend changes
      const funcionariosRes = await axios.get(`/api/funcionarios?entidade_id=${currentEntidade.id}`);
      setAllFuncionarios(funcionariosRes.data.funcionarios || []);
    } catch (error) {
      console.error('Error creating funcionario:', error);
      setFuncionarioMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao criar funcionário.' });
    } finally {
        setCreatingFuncionario(false);
    }
  };

  const handleDeleteFuncionario = async (funcionarioId) => {
    try {
      setDeletingFuncionario(true);
      setFuncionarioMessage(null);
      const response = await axios.delete(`/api/funcionarios/${funcionarioId}`);
      setAllFuncionarios(allFuncionarios.filter(f => f.id !== funcionarioId));
      setFuncionarioMessage({ type: 'success', text: response.data.message || 'Funcionário excluído com sucesso!' });
    } catch (error) {
      console.error('Error deleting funcionario:', error);
      setFuncionarioMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao excluir funcionário.' });
    } finally {
      setDeletingFuncionario(false);
    }
  };

  // Função para BUSCAR uma folha de pagamento existente
  const fetchFolhaPagamentoExistente = async (mes, ano, entidadeId) => {
    setIsLoadingFolha(true);
    setDadosFolhaPagamento([]);
    setResumoFolha({ totalBruto: 0, totalDescontos: 0, totalLiquido: 0, statusFolha: 'Pendente' });
    try {
      const response = await axios.get('/api/folha-pagamento', {
        params: {
          entidade_id: entidadeId,
          mes: mes,
          ano: ano,
        }
      });
      setDadosFolhaPagamento(response.data.dadosFolha || []);
      setResumoFolha(response.data.resumoFolha || { totalBruto: 0, totalDescontos: 0, totalLiquido: 0, statusFolha: 'Pendente' });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // Folha não encontrada, o que é esperado se ainda não foi gerada
        setDadosFolhaPagamento([]);
        setResumoFolha({ totalBruto: 0, totalDescontos: 0, totalLiquido: 0, statusFolha: 'NaoGerada' });
      } else {
        console.error('Erro ao buscar folha de pagamento existente:', error);
        alert(`Erro ao buscar folha: ${error.response?.data?.message || error.message}`);
      }
    } finally {
      setIsLoadingFolha(false);
    }
  };

  // Efeito para buscar a folha ao mudar o período ou a entidade
  useEffect(() => {
    if (currentEntidade && activePessoalTab === 'folhaPagamento') {
      fetchFolhaPagamentoExistente(mesFolha, anoFolha, currentEntidade.id);
    }
  }, [mesFolha, anoFolha, currentEntidade, activePessoalTab]);


  const handleGerarOuVisualizarFolha = async () => {
    if (!currentEntidade) {
      alert("Entidade não carregada. Não é possível gerar a folha.");
      return;
    }
    // Se a folha não existe ou está pendente, tenta gerar. Caso contrário, apenas busca novamente (refresh).
    if (resumoFolha?.statusFolha === 'NaoGerada' || resumoFolha?.statusFolha === 'Pendente' || resumoFolha?.statusFolha === 'Em Processamento') {
      setIsLoadingFolha(true);
      const gerarResponse = await axios.post('/api/folha-pagamento/gerar', {
        entidade_id: currentEntidade.id,
        mes: mesFolha,
        ano: anoFolha,
      });

      if (gerarResponse.status === 201 || gerarResponse.status === 200) { // 201 para criada, 200 se já existia e foi atualizada
        fetchFolhaPagamentoExistente(mesFolha, anoFolha, currentEntidade.id); // Busca os dados após gerar
      } else {
        alert(`Erro ao gerar folha: ${gerarResponse.data.message || 'Status inesperado.'}`);
        setIsLoadingFolha(false);
      }
    } else {
      // Se a folha já está 'Processada' ou 'Paga', apenas faz um refresh dos dados.
      fetchFolhaPagamentoExistente(mesFolha, anoFolha, currentEntidade.id);
    }
  };

  const handleProcessarFolhaFinal = async () => {
    if (!currentEntidade || !resumoFolha || dadosFolhaPagamento.length === 0) {
      alert("Não há uma folha gerada para processar ou entidade não carregada.");
      return;
    }

    if (window.confirm(`Tem certeza que deseja processar e finalizar a folha de ${String(mesFolha).padStart(2, '0')}/${anoFolha}? Esta ação geralmente não pode ser desfeita.`)) {
      setIsProcessingFolhaFinal(true);
      try {
        const response = await axios.post('/api/folha-pagamento/processar-final', {
          entidade_id: currentEntidade.id,
          mes: mesFolha,
          ano: anoFolha,
        });

        if (response.status === 200) {
          alert(response.data.message || "Folha processada com sucesso!");
          // Atualiza o status da folha no resumo e nos itens
          setResumoFolha(prev => ({ ...prev, statusFolha: response.data.folhaPagamento?.status || 'Paga' }));
          setDadosFolhaPagamento(prevDados => prevDados.map(item => ({ ...item, status: response.data.folhaPagamento?.status || 'Paga' })));
        } else {
          alert(`Erro ao processar folha: ${response.data.message || 'Status inesperado.'}`);
        }
      } catch (error) {
        console.error('Erro ao processar folha final:', error);
        alert(`Erro ao processar folha: ${error.response?.data?.message || error.message}`);
      } finally {
        setIsProcessingFolhaFinal(false);
      }
    }
  };

  // --- Lógica para Lançamentos Variáveis (Funções Globais no Componente) ---
  const handleFetchLancamentos = async (funcionarioIdToFetch) => {
    // Usa o ID do funcionário passado como parâmetro
    if (!funcionarioIdToFetch || !currentEntidade) {

      setLancamentosVariaveis([]);
      // Não definir mensagem aqui para não sobrescrever mensagens de sucesso/erro de outras operações
      // A aba de lançamentos pode ter sua própria lógica de mensagem se nenhum funcionário for selecionado.
      return;
    }
    setIsLoadingLancamentos(true);
    // Não limpar lancamentoMessage aqui para não apagar feedback de save/delete
    try {
      const response = await axios.get(`/api/funcionarios/${funcionarioIdToFetch}/lancamentos-variaveis`, { // Usa funcionarioIdToFetch na URL
        params: { 
          entidade_id: currentEntidade.id,
          mes: mesLancamento, 
          ano: anoLancamento, 
        }
      });
      setLancamentosVariaveis(response.data || []);
      // A mensagem de "nenhum lançamento" pode ser tratada na UI da aba ou do modal
    } catch (error) {
      console.error('Erro ao buscar lançamentos variáveis:', error);
      setLancamentoMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao buscar lançamentos variáveis.' });
      setLancamentosVariaveis([]);
    } finally {
      setIsLoadingLancamentos(false);
    }
  };

  // --- Lógica para o NOVO Modal de Lançamentos Variáveis ---
  const handleOpenNovoLancamentoModal = (funcionario, lancamento = null) => {
    setSelectedFuncionarioLancamento(funcionario.id);
    if (lancamento) {
      setCurrentLancamentoVariavel(lancamento);
      setNewLancamentoVariavelData({
        descricao: lancamento.descricao,
        tipo: lancamento.tipo,
        valor: lancamento.valor,
        referencia: lancamento.referencia || '',
      });
    } else {
      setCurrentLancamentoVariavel(null);
      setNewLancamentoVariavelData({
        descricao: '',
        tipo: 'provento',
        valor: '',
        referencia: '',
      });
    }
    handleFetchLancamentos(funcionario.id); 
    setShowLancamentoVariavelModal(true);
  };

  const handleCloseNovoLancamentoModal = () => {
    setShowLancamentoVariavelModal(false);
    setCurrentLancamentoVariavel(null);
    setLancamentoMessage(null); 
  };

  const handleLancamentoVariavelInputChange = (e) => {
    const { name, value } = e.target;
    setNewLancamentoVariavelData(prev => ({ ...prev, [name]: value }));
  };

  const handleSaveNovoLancamentoVariavel = async () => {
    // ... (código da função handleSaveNovoLancamentoVariavel como estava antes)
    // Certifique-se que a chamada a handleFetchLancamentos aqui esteja correta:
    // handleFetchLancamentos(selectedFuncionarioLancamento);
    // ... (resto do código da função)
    if (!selectedFuncionarioLancamento || !currentEntidade) {
      setLancamentoMessage({ type: 'danger', text: 'Funcionário ou entidade não selecionados.' });
      return;
    }
    if (!newLancamentoVariavelData.descricao || !newLancamentoVariavelData.valor) {
        setLancamentoMessage({ type: 'danger', text: 'Descrição e Valor são obrigatórios.' });
        return;
    }

    const url = currentLancamentoVariavel
      ? `/api/lancamentos-variaveis/${currentLancamentoVariavel.id}`
      : '/api/lancamentos-variaveis';
    const method = currentLancamentoVariavel ? 'put' : 'post';

    const payload = {
      funcionario_id: selectedFuncionarioLancamento,
      entidade_id: currentEntidade.id,
      mes: mesLancamento, 
      ano: anoLancamento, 
      descricao: newLancamentoVariavelData.descricao,
      tipo: newLancamentoVariavelData.tipo,
      valor: parseFloat(newLancamentoVariavelData.valor),
      referencia: newLancamentoVariavelData.referencia,
    };

    try {
      await axios[method](url, payload);
      setLancamentoMessage({ type: 'success', text: `Lançamento ${currentLancamentoVariavel ? 'atualizado' : 'salvo'} com sucesso!` });
      handleFetchLancamentos(selectedFuncionarioLancamento); 
      handleCloseNovoLancamentoModal();
    } catch (error) {
      console.error('Erro ao salvar lançamento variável:', error);
      setLancamentoMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao salvar lançamento.' });
    }
  };

  const handleDeleteLancamento = async (lancamentoId) => {
    if (window.confirm('Tem certeza que deseja excluir este lançamento?')) {
      try {
        await axios.delete(`/api/lancamentos-variaveis/${lancamentoId}`);
        setLancamentoMessage({ type: 'success', text: 'Lançamento excluído com sucesso!' });
        if (selectedFuncionarioLancamento) { 
          handleFetchLancamentos(selectedFuncionarioLancamento); 
        }
      } catch (error) {
        console.error('Erro ao excluir lançamento:', error);
        setLancamentoMessage({ type: 'danger', text: error.response?.data?.message || 'Erro ao excluir lançamento.' });
      }
    }
  };

  // useEffect para buscar lançamentos quando o funcionário/período/entidade muda na aba de lançamentos
  useEffect(() => {
    if (activePessoalTab === 'lancamentosVariaveis' && selectedFuncionarioLancamento && currentEntidade) {
      handleFetchLancamentos(selectedFuncionarioLancamento); // Passa o ID do estado
    } else if (activePessoalTab === 'lancamentosVariaveis' && !selectedFuncionarioLancamento) {
       setLancamentosVariaveis([]);
       setLancamentoMessage({ type: 'info', text: 'Selecione um funcionário e período para buscar lançamentos.' });
    }
  }, [activePessoalTab, selectedFuncionarioLancamento, mesLancamento, anoLancamento, currentEntidade]);

    // --- Lógica para o Modal de Detalhes do Holerite ---
  const handleOpenDetalhesHoleriteModal = async (itemFolha) => {
    // 'itemFolha' é o objeto do funcionário vindo de 'dadosFolhaPagamento'
    // Vamos assumir que 'itemFolha' já contém os lançamentos ou um ID para buscá-los.
    // Para esta implementação, vamos simular que os lançamentos já estão em 'itemFolha.lancamentos'
    // Se não estiverem, você precisará fazer uma chamada API aqui para buscar os detalhes do holerite.

    setIsLoadingDetalhesHolerite(true);
    // Simulação de busca de detalhes (se necessário)
    // await new Promise(resolve => setTimeout(resolve, 500)); 

    // Exemplo de como seria se você precisasse buscar os lançamentos:
    // try {
    //   const response = await axios.get(`/api/holerites/${itemFolha.holerite_id_real_do_banco}/detalhes`);
    //   setHoleriteSelecionadoDetalhes(response.data);
    // } catch (error) {
    //   console.error("Erro ao buscar detalhes do holerite:", error);
    //   setHoleriteSelecionadoDetalhes({ ...itemFolha, lancamentos: [] }); // Fallback
    // }
    
    // Usa os lançamentos que vêm da API (itemFolha.lancamentos). A comissão será um desses lançamentos.
    // O objeto `itemFolha` já contém os totais (salarioBase, adicionais, etc.) que são calculados no backend.
    setHoleriteSelecionadoDetalhes({ ...itemFolha });
    setIsLoadingDetalhesHolerite(false);
    setShowDetalhesHoleriteModal(true);
  };

  const handleCloseDetalhesHoleriteModal = () => {
    setShowDetalhesHoleriteModal(false);
    setHoleriteSelecionadoDetalhes(null);
  };

  const handlePrintHolerite = () => {
    window.print();
  };


    return (
    <div style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif", backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        .pessoal-tab-btn {
          padding: 12px 18px; border: none; background: none;
          font-size: calc(13px * var(--font-scale)) font-weight: 500; color: #6b7280;
          border-bottom: 2px solid transparent; margin-bottom: -2px;
          cursor: pointer; transition: all 0.15s; white-space: nowrap;
          font-family: 'Inter', 'Segoe UI', sans-serif;
        }
        .pessoal-tab-btn:hover { color: #374151; background: #f9fafb; border-radius: 6px 6px 0 0; }
        .pessoal-tab-btn.active { color: #2563eb; border-bottom-color: #2563eb; font-weight: 600; }
        .modal-header { padding: 0 !important; border: none !important; }
        .modal-header .btn-close { display: none !important; }
      `}</style>

      {/* ── CABEÇALHO ── */}
      <div style={{
        background: 'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',
        padding: '20px 28px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <img src={logoImage} alt="Logo" style={{ height: '44px', width: 'auto', opacity: 0.9 }} />
          <div>
            <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#fff' }}>
              Gestão de Pessoal
            </h2>
            <p style={{ margin: 0, fontSize: `calc(12px * var(--font-scale))`, color: 'rgba(255,255,255,0.7)' }}>
              {currentEntidade?.nome || 'Clínica'}
            </p>
          </div>
        </div>
        <div style={{
          padding: '4px 12px', borderRadius: '999px',
          backgroundColor: 'rgba(255,255,255,0.15)',
          fontSize: `calc(12px * var(--font-scale))`, fontWeight: '600', color: '#fff',
          border: '1px solid rgba(255,255,255,0.25)',
        }}>
          {currentUserRole}
        </div>
      </div>

      {/* ── ABAS ── */}
      <div style={{ backgroundColor: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
        <div style={{ display: 'flex', borderBottom: '2px solid #e2e8f0', padding: '0 24px', gap: '4px', flexWrap: 'wrap' }}>
          {permittedTabs.map(tab => (
            <button
              key={tab.key}
              className={`pessoal-tab-btn ${activePessoalTab === tab.key ? 'active' : ''}`}
              onClick={() => setActivePessoalTab(tab.key)}
            >
              {tab.title}
            </button>
          ))}
        </div>
      </div>

      {/* ── CONTEÚDO DAS ABAS ── */}
      <div style={{ padding: '24px 28px' }}>
        {permittedTabs.map(tab => {
          if (activePessoalTab !== tab.key) return null;

          if (tab.key === 'colaboradores') return (
            <ColaboradoresTab
              key={tab.key}
              allFuncionarios={allFuncionarios}
              isLoadingFuncionarios={isLoadingFuncionarios}
              funcionarioMessage={funcionarioMessage}
              setFuncionarioMessage={setFuncionarioMessage}
              handleOpenFuncionarioModal={handleOpenFuncionarioModal}
              handleDeleteFuncionario={handleDeleteFuncionario}
              deletingFuncionario={deletingFuncionario}
              handleOpenNovoLancamentoModal={handleOpenNovoLancamentoModal}
              showFuncionarioModal={showFuncionarioModal}
              handleCloseFuncionarioModal={handleCloseFuncionarioModal}
              isEditingFuncionario={isEditingFuncionario}
              newFuncionarioData={newFuncionarioData}
              handleFuncionarioInputChange={handleFuncionarioInputChange}
              handleSaveFuncionario={handleSaveFuncionario}
              creatingFuncionario={creatingFuncionario}
              selectedSetorModal={selectedSetorModal}
              setSelectedSetorModal={setSelectedSetorModal}
              setores={setores}
              cargosDoSetorModal={cargosDoSetorModal}
              isLoadingCargosModal={isLoadingCargosModal}
              especialidades={especialidades}
              perfis={perfis}
              setNewFuncionarioData={setNewFuncionarioData}
            />
          );

          if (tab.key === 'folhaPagamento') return (
            <FolhaPagamentoTab
              key={tab.key}
              mesFolha={mesFolha}
              setMesFolha={setMesFolha}
              anoFolha={anoFolha}
              setAnoFolha={setAnoFolha}
              dadosFolhaPagamento={dadosFolhaPagamento}
              isLoadingFolha={isLoadingFolha}
              resumoFolha={resumoFolha}
              isProcessingFolhaFinal={isProcessingFolhaFinal}
              handleGerarOuVisualizarFolha={handleGerarOuVisualizarFolha}
              handleProcessarFolhaFinal={handleProcessarFolhaFinal}
              handleOpenDetalhesHoleriteModal={handleOpenDetalhesHoleriteModal}
            />
          );

          return null;
        })}
      </div>

      {/* ══ MODAL: LANÇAMENTO VARIÁVEL ══ */}
      <Modal show={showLancamentoVariavelModal} onHide={handleCloseNovoLancamentoModal} centered>
        <Modal.Header style={{ padding: '0', border: 'none' }}>
          <div style={{
            width: '100%', padding: '20px 24px',
            background: 'linear-gradient(135deg, #1e3a5f, #2563eb)',
            display: 'flex', alignItems: 'center', gap: '12px',
          }}>
            <div style={{ width: '40px', height: '40px', borderRadius: '10px', backgroundColor: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <svg width="20" height="20" fill="none" stroke="white" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#fff' }}>
                {currentLancamentoVariavel ? 'Editar Lançamento Variável' : 'Novo Lançamento Variável'}
              </div>
              {selectedFuncionarioLancamento && allFuncionarios.find(f => f.id === selectedFuncionarioLancamento) && (
                <div style={{ fontSize: `calc(11px * var(--font-scale))`, color: 'rgba(255,255,255,0.75)', marginTop: '2px' }}>
                  {allFuncionarios.find(f => f.id === selectedFuncionarioLancamento).nome} — {String(mesLancamento).padStart(2, '0')}/{anoLancamento}
                </div>
              )}
            </div>
            <button onClick={handleCloseNovoLancamentoModal}
              style={{ width: '28px', height: '28px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.3)', backgroundColor: 'rgba(255,255,255,0.15)', color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', lineHeight: 1, flexShrink: 0 }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.25)'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)'}
            >×</button>
          </div>
        </Modal.Header>

        <Modal.Body style={{ padding: '20px', backgroundColor: '#f9fafb', maxHeight: '70vh', overflowY: 'auto' }}>
          {lancamentoMessage && (
            <div style={{
              padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: `calc(13px * var(--font-scale))`,
              backgroundColor: lancamentoMessage.type === 'success' ? '#f0fdf4' : lancamentoMessage.type === 'danger' ? '#fef2f2' : '#eff6ff',
              color: lancamentoMessage.type === 'success' ? '#16a34a' : lancamentoMessage.type === 'danger' ? '#dc2626' : '#2563eb',
              border: `1px solid ${lancamentoMessage.type === 'success' ? '#bbf7d0' : lancamentoMessage.type === 'danger' ? '#fecaca' : '#bfdbfe'}`,
            }}>
              {lancamentoMessage.text}
            </div>
          )}

          {/* Formulário */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '20px' }}>
            {/* Descrição */}
            <div>
              <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '5px' }}>Descrição *</label>
              <input type="text" name="descricao" value={newLancamentoVariavelData.descricao} onChange={handleLancamentoVariavelInputChange} required
                style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151', fontFamily: 'inherit', outline: 'none', backgroundColor: '#fff' }}
                onFocus={e => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 3px rgba(59,130,246,0.1)'; }}
                onBlur={e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; }}
              />
            </div>
            {/* Tipo + Valor */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div>
                <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '5px' }}>Tipo *</label>
                <select name="tipo" value={newLancamentoVariavelData.tipo} onChange={handleLancamentoVariavelInputChange} required
                  style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151', fontFamily: 'inherit', outline: 'none', backgroundColor: '#fff' }}
                  onFocus={e => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 3px rgba(59,130,246,0.1)'; }}
                  onBlur={e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; }}
                >
                  <option value="provento">Provento</option>
                  <option value="desconto">Desconto</option>
                </select>
              </div>
              <div>
                <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '5px' }}>Valor (R$) *</label>
                <input type="number" step="0.01" name="valor" value={newLancamentoVariavelData.valor} onChange={handleLancamentoVariavelInputChange} required min="0" placeholder="0.00"
                  style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151', fontFamily: 'inherit', outline: 'none', backgroundColor: '#fff' }}
                  onFocus={e => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 3px rgba(59,130,246,0.1)'; }}
                  onBlur={e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; }}
                />
              </div>
            </div>
            {/* Referência */}
            <div>
              <label style={{ fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '5px' }}>Referência</label>
              <input type="text" name="referencia" value={newLancamentoVariavelData.referencia} onChange={handleLancamentoVariavelInputChange}
                style={{ width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: `calc(13px * var(--font-scale))`, color: '#374151', fontFamily: 'inherit', outline: 'none', backgroundColor: '#fff' }}
                onFocus={e => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 3px rgba(59,130,246,0.1)'; }}
                onBlur={e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; }}
              />
            </div>
            {/* Botões do formulário */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
              {currentLancamentoVariavel && (
                <button onClick={() => { setCurrentLancamentoVariavel(null); setNewLancamentoVariavelData({ descricao: '', tipo: 'provento', valor: '', referencia: '' }); }}
                  style={{ padding: '8px 14px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', cursor: 'pointer', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500', fontFamily: 'inherit' }}>
                  Cancelar Edição
                </button>
              )}
              <button onClick={handleSaveNovoLancamentoVariavel}
                style={{ padding: '8px 20px', borderRadius: '8px', border: 'none', background: 'linear-gradient(135deg, #1e3a5f, #2563eb)', color: '#fff', cursor: 'pointer', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', fontFamily: 'inherit', boxShadow: '0 2px 8px rgba(37,99,235,0.3)' }}>
                {currentLancamentoVariavel ? 'Atualizar' : 'Adicionar Lançamento'}
              </button>
            </div>
          </div>

          {/* Divisor */}
          <div style={{ height: '1px', backgroundColor: '#e5e7eb', margin: '4px 0 16px' }} />
          <p style={{ fontSize: `calc(12px * var(--font-scale))`, fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '12px' }}>Lançamentos Existentes</p>

          {isLoadingLancamentos ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '20px', color: '#6b7280', fontSize: `calc(13px * var(--font-scale))` }}>
              <Spinner animation="border" size="sm" variant="primary" /> Carregando...
            </div>
          ) : lancamentosVariaveis.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {lancamentosVariaveis.map(lanc => (
                <div key={lanc.id} style={{
                  padding: '10px 14px', borderRadius: '8px', border: '1px solid #e5e7eb',
                  backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px',
                }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', color: '#111827' }}>{lanc.descricao}</div>
                    <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                      <span style={{ fontSize: `calc(11px * var(--font-scale))`, padding: '1px 7px', borderRadius: '999px', backgroundColor: lanc.tipo === 'provento' ? '#f0fdf4' : '#fef2f2', color: lanc.tipo === 'provento' ? '#16a34a' : '#dc2626' }}>
                        {lanc.tipo === 'provento' ? 'Provento' : 'Desconto'}
                      </span>
                      {lanc.referencia && <span style={{ fontSize: `calc(11px * var(--font-scale))`, color: '#9ca3af' }}>{lanc.referencia}</span>}
                    </div>
                  </div>
                  <div style={{ fontWeight: '700', color: '#111827', fontSize: `calc(14px * var(--font-scale))`, whiteSpace: 'nowrap' }}>
                    R$ {parseFloat(lanc.valor).toFixed(2).replace('.', ',')}
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button onClick={() => handleOpenNovoLancamentoModal(allFuncionarios.find(f => f.id === selectedFuncionarioLancamento), lanc)}
                      style={{ padding: '5px 10px', borderRadius: '6px', border: '1px solid #bfdbfe', background: '#eff6ff', color: '#2563eb', fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit' }}>
                      Editar
                    </button>
                    <button onClick={() => handleDeleteLancamento(lanc.id)}
                      style={{ padding: '5px 10px', borderRadius: '6px', border: '1px solid #fecaca', background: '#fef2f2', color: '#dc2626', fontSize: `calc(11px * var(--font-scale))`, fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit' }}>
                      Excluir
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p style={{ fontSize: `calc(13px * var(--font-scale))`, color: '#9ca3af', textAlign: 'center', padding: '20px 0' }}>
              Nenhum lançamento encontrado para este funcionário e período.
            </p>
          )}
        </Modal.Body>

        <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px', backgroundColor: '#fff' }}>
          <button onClick={handleCloseNovoLancamentoModal}
            style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', cursor: 'pointer', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500', fontFamily: 'inherit' }}>
            Fechar
          </button>
        </Modal.Footer>
      </Modal>

      {/* ══ MODAL: HOLERITE ══ */}
      <Modal show={showDetalhesHoleriteModal} onHide={handleCloseDetalhesHoleriteModal} size="lg" centered>
        <Modal.Header style={{ padding: '0', border: 'none' }}>
          <div style={{
            width: '100%', padding: '20px 24px',
            background: 'linear-gradient(135deg, #1e3a5f, #2563eb)',
            display: 'flex', alignItems: 'center', gap: '12px',
          }}>
            <div style={{ width: '40px', height: '40px', borderRadius: '10px', backgroundColor: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <svg width="20" height="20" fill="none" stroke="white" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: `calc(15px * var(--font-scale))`, fontWeight: '700', color: '#fff' }}>Holerite</div>
              {holeriteSelecionadoDetalhes && (
                <div style={{ fontSize: `calc(11px * var(--font-scale))`, color: 'rgba(255,255,255,0.75)', marginTop: '2px' }}>
                  {holeriteSelecionadoDetalhes.nome} — {String(mesFolha).padStart(2, '0')}/{anoFolha}
                </div>
              )}
            </div>
            <button onClick={handleCloseDetalhesHoleriteModal}
              style={{ width: '28px', height: '28px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.3)', backgroundColor: 'rgba(255,255,255,0.15)', color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', lineHeight: 1, flexShrink: 0 }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.25)'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)'}
            >×</button>
          </div>
        </Modal.Header>

        <Modal.Body style={{ padding: '24px', backgroundColor: '#f9fafb' }} className="printable-content">
          {isLoadingDetalhesHolerite ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
              <Spinner animation="border" variant="primary" />
            </div>
          ) : holeriteSelecionadoDetalhes ? (
            <>
              {/* Cabeçalho do holerite */}
              <div style={{ backgroundColor: '#fff', borderRadius: '10px', border: '1px solid #e5e7eb', padding: '16px 20px', marginBottom: '16px' }}>
                <div style={{ fontWeight: '700', fontSize: '16px', color: '#111827' }}>{currentEntidade?.nome}</div>
                <div style={{ fontSize: `calc(12px * var(--font-scale))`, color: '#6b7280', marginTop: '2px' }}>CNPJ: {currentEntidade?.cnpj}</div>
                <div style={{ height: '1px', backgroundColor: '#f1f5f9', margin: '12px 0' }} />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                  {[
                    { label: 'Funcionário', value: holeriteSelecionadoDetalhes.nome },
                    { label: 'Cargo', value: holeriteSelecionadoDetalhes.cargo },
                    { label: 'Período', value: `${String(mesFolha).padStart(2, '0')}/${anoFolha}` },
                  ].map(item => (
                    <div key={item.label}>
                      <div style={{ fontSize: `calc(10px * var(--font-scale))`, fontWeight: '700', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{item.label}</div>
                      <div style={{ fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600', color: '#374151', marginTop: '2px' }}>{item.value}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Tabela de eventos */}
              <div style={{ backgroundColor: '#fff', borderRadius: '10px', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)', borderBottom: '2px solid #e2e8f0' }}>
                      {['Descrição do Evento', 'Proventos (R$)', 'Descontos (R$)'].map(h => (
                        <th key={h} style={{ padding: '10px 16px', fontSize: `calc(11px * var(--font-scale))`, fontWeight: '700', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px', textAlign: h === 'Descrição do Evento' ? 'left' : 'right' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {holeriteSelecionadoDetalhes.lancamentos?.map((lanc, index) => (
                      <tr key={lanc.id || index} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: '10px 16px', fontSize: `calc(13px * var(--font-scale))`, color: '#374151' }}>{lanc.descricao_evento_historico || lanc.descricao}</td>
                        <td style={{ padding: '10px 16px', fontSize: `calc(13px * var(--font-scale))`, color: '#16a34a', fontWeight: '600', textAlign: 'right' }}>
                          {lanc.tipo_evento_historico === 'provento' ? formatCurrency(lanc.valor_calculado) : '—'}
                        </td>
                        <td style={{ padding: '10px 16px', fontSize: `calc(13px * var(--font-scale))`, color: '#dc2626', fontWeight: '600', textAlign: 'right' }}>
                          {lanc.tipo_evento_historico === 'desconto' ? formatCurrency(lanc.valor_calculado) : '—'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr style={{ borderTop: '2px solid #e2e8f0', backgroundColor: '#f8fafc' }}>
                      <td style={{ padding: '10px 16px', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#111827' }}>TOTAIS</td>
                      <td style={{ padding: '10px 16px', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#16a34a', textAlign: 'right' }}>{formatCurrency(holeriteSelecionadoDetalhes.total_proventos)}</td>
                      <td style={{ padding: '10px 16px', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '700', color: '#dc2626', textAlign: 'right' }}>{formatCurrency(holeriteSelecionadoDetalhes.totalDescontos)}</td>
                    </tr>
                    <tr style={{ backgroundColor: '#eff6ff' }}>
                      <td colSpan={2} style={{ padding: '12px 16px', fontSize: `calc(14px * var(--font-scale))`, fontWeight: '700', color: '#1e3a5f', textAlign: 'right' }}>VALOR LÍQUIDO:</td>
                      <td style={{ padding: '12px 16px', fontSize: '16px', fontWeight: '800', color: '#1e3a5f', textAlign: 'right' }}>
                        R$ {parseFloat(holeriteSelecionadoDetalhes.valorLiquido).toFixed(2).replace('.', ',')}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </>
          ) : (
            <p style={{ textAlign: 'center', color: '#9ca3af', fontSize: `calc(14px * var(--font-scale))`, padding: '40px 0' }}>Nenhum detalhe para exibir.</p>
          )}
        </Modal.Body>

        <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '12px 20px', gap: '8px', backgroundColor: '#fff' }}>
          <button onClick={handleCloseDetalhesHoleriteModal}
            style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb', backgroundColor: '#fff', color: '#374151', cursor: 'pointer', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '500', fontFamily: 'inherit' }}>
            Fechar
          </button>
          <button
            onClick={handlePrintHolerite}
            style={{
              padding: '8px 20px', borderRadius: '8px', border: 'none',
              background: 'linear-gradient(135deg, #1e3a5f, #2563eb)',
              color: '#fff', cursor: 'pointer', fontSize: `calc(13px * var(--font-scale))`, fontWeight: '600',
              fontFamily: 'inherit', display: 'flex', alignItems: 'center', gap: '8px',
              boxShadow: '0 2px 8px rgba(37,99,235,0.3)',
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          >
            <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
            </svg>
            Imprimir
          </button>
        </Modal.Footer>
      </Modal>

    </div>
  );

};

export default PessoalPage;
